<template>
  <div
    ref="select"
    class="country-switch"
    @keyup.esc="triggerClose"
  >
    <button
      type="button"
      class="country-switch__button"
      @click="triggerToggle"
    >
      <span>{{ selectedOption?.key?.toUpperCase() }}</span>

      <svg
        class="icon icon--arrow"
        viewBox="0 0 7 5"
      >
        <path d="M6.08836 0.145925C6.29188 0.0467162 6.61091 0.00951239 6.77593 0.133524C6.92444 0.245134 7.05096 0.666773 6.97945 0.840388C6.74842 1.38604 6.4679 1.92549 6.12136 2.39053C5.4998 3.22141 4.81773 4.00888 4.06415 4.93896C3.49209 4.98857 2.92553 4.73434 2.44698 4.10809C1.89143 3.37642 1.27537 2.69436 0.692306 1.98749C0.565793 1.83868 0.411777 1.67746 0.367772 1.49145C0.307267 1.24963 0.263262 0.908594 0.367772 0.734978C0.472283 0.561362 0.796817 0.42495 0.989336 0.468354L6.08836 0.145925Z" />
      </svg>
    </button>

    <menu
      v-show="isOpen"
      class="country-switch__list"
    >
      <li
        v-for="hrefLang in hrefLangs"
        :key="hrefLang.key"
        class="country-switch__item"
      >
        <a
          :href="hrefLang.value"
          class="country-switch__option"
          @click="onClick($event, hrefLang)"
        >
          <span class="icon icon--flag">{{ hrefLang.flag }}</span>
          <span class="country-switch__label">{{ hrefLang.label }}</span>
        </a>
      </li>
    </menu>

    <!-- <pre>selectedOption: {{ selectedOption }}</pre> -->
  </div>
</template>

<script lang="ts" setup>
/* eslint-disable @typescript-eslint/no-explicit-any */
const select = useTemplateRef('select')

const { public: config } = useRuntimeConfig()
const { locale, setLocale } = useI18n({ useScope: 'global' })

const hrefLangs = computed(() => {
  return config?.i18n?.locales?.filter((item: any) => item.storeCode)?.map((item: any) => {
    return {
      selected: item?.code === locale.value,
      key: item?.code,
      label: item?.name,
      flag: item?.flag,
      // value: item?.domain + useSanitizeUrl('/' + path),
      value: item?.domain,
    }
  }) || []
})

const selectedOption = computed(() => {
  return hrefLangs.value.find((option: any) => option.selected)
})

const isOpen = ref(false)

const triggerToggle = () => {
  isOpen.value = !isOpen.value
}

const triggerClose = () => {
  isOpen.value = false
}

const onClick = (e, hrefLang) => {
  if (config.isDev) {
    setLocale(hrefLang.key)
    e.preventDefault()
  }
}

onClickOutside(select, triggerClose)
</script>

<style src="~layers/app/components/App/CountrySwitch.css" />
